<script setup lang="ts">
import {ref} from 'vue';

import AppMenuItem from './AppMenuItem.vue';
import {EPermissao} from "@/stores/enums/EPermissao";
import {useAuthStore} from "@/stores/auth.store";

const authStore = useAuthStore();
const {temPermissao} = authStore;

const model: any = ref([
  {
    label: 'Menu',
    items: [{label: 'Home', icon: 'pi pi-fw pi-home', to: '/'}]
  },
  {
    label: 'ADMIN',
    visible: temPermissao(EPermissao.ADMIN),
    items: [
      {
        label: "Empresas",
        icon: "pi pi-fw pi-shop",
        to: {name: 'empresas'},
        visible: temPermissao(EPermissao.ADMIN_EMPRESAS)
      },
      {
        label: 'Colaboradores',
        icon: "pi pi-fw pi-id-card",
        to: {name: "colaboradores"},
        visible: temPermissao(EPermissao.ADMIN_COLABORADORES)
      },
      {
        label: "Loja",
        visible: temPermissao(EPermissao.ADMIN_LOJA),
        items: [
          {
            label: "Comissão",
            icon: "pi pi-wallet",
            to: {name: "comissoes"},
            visible: temPermissao(EPermissao.ADMIN_LOJA_COMISSAO)
          },
          {
            label: "Desconto",
            icon: 'pi pi-percentage',
            to:{name: 'empresaDescontos'},
            visible: temPermissao(EPermissao.ADMIN_LOJA_DESCONTO)
          },
          {
            label: "Metas de Vendas",
            icon: "pi  pi-chart-line",
            to: {name: "metasVendas"},
            visible: temPermissao(EPermissao.ADMIN_LOJA_METASVENDA)
          },
          {
            label: "Tarifas",
            icon: "pi  pi-tag",
            to: {name: "tarifas"},
            //visible: temPermissao(EPermissao.ADMIN_LOJA_TARIFA)
            visible:false
          },
        ]
      },
      {
        label: "Cadastros",
        items: [
          {
            label: 'Grupo de Permissão',
            icon: "pi pi-fw pi-unlock",
            to: {name: "grupoPermissao"},
            visible: temPermissao(EPermissao.ADMIN_CADASTRO_GRUPOPERMISSAO)
          },
          {
            label: "Planos de Seguro",
            icon: "pi pi-shield",
            to: {name: "planoSeguro"},
            visible: temPermissao(EPermissao.ADMIN_CADASTRO_PLANOSEGURO)
          },

        ]
      }

    ]
  },
  {
    label: "OPERAÇÃO",
    visible: temPermissao(EPermissao.OPERACAO),
    items: [
      {
        label: "Vendas",
        icon: "pi pi-shopping-cart",
        to: {name: "vendas"},
        visible: temPermissao(EPermissao.OPERACAO_VENDA)
      },
      {
        label: "Clientes",
        icon: "pi pi-users",
        to: {name: "clientes"},
        visible: temPermissao(EPermissao.OPERACAO_CLIENTE)
      },
      {
        label: "Seguros",
        icon: "pi  pi-shield",
        to: {name: "seguros"},
        visible: temPermissao(EPermissao.OPERACAO_SEGURO)
      },
      {
        label: "Sinistros",
        icon: "pi  pi-shield",
        to: {name: "sinistros"},
        visible: temPermissao(EPermissao.OPERACAO_SINISTRO)
      },

    ]
  },

  {
    label: "FINANCEIRO",
    visible: temPermissao(EPermissao.FINANCEIRO),
    items: [
      {
        label: "Lançamentos",
        icon: "pi pi-dollar",
        to: {name: "lancamentos"},
        visible: temPermissao(EPermissao.FINANCEIRO_LANCAMENTO)
      }
    ]
  },

  {
    label: "RELATÓRIOS",
    visible: temPermissao(EPermissao.RELATORIO),
    items: [
      {
        label: "Comissão",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_comissao"},
        visible: temPermissao(EPermissao.RELATORIO_COMISSAO_VISUALIZAR_RELATORIO)
      },
      {
        label: "Produto Vendido",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_produto_vendido"},
        visible: temPermissao(EPermissao.RELATORIO_PRODUTOVENDIDO)
      },
      {
        label: "DRE - Forma Pagamento",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_dre"},
        visible: temPermissao(EPermissao.RELATORIO_DRE_FORMAPAGAMENTO)
      },
      {
        label: "Fechamento Vendedor",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_fechamento_vendedor"},
        visible: temPermissao(EPermissao.RELATORIO_FECHAMENTOVENDEDOR)
      },
      {
        label: "Ranking Loja",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_ranking_loja_ps"},
        visible: temPermissao(EPermissao.RELATORIO_RANKINGLOJA)
      },
      {
        label: "Metas de Loja",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_metas"},
        visible: temPermissao(EPermissao.RELATORIO_METASVENDA_VISUALIZAR_RELATORIO)
      },
      {
        label: "Metas de Colaborador",
        icon: "pi pi-fw pi-file",
        to: {name: "relatorio_metas_colaborador"},
        visible: temPermissao(EPermissao.RELATORIO_METASCOLABORADOR)
      },
    ]
  }

]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
